// Estado del menú lateral, para el shell y para las NavSecundaria de los módulos.
//   const { alNavegar } = useNavegacion();
//   <Link to="/chat/12" onClick={alNavegar}>…</Link>   ← en móvil cierra el cajón (como la de siempre, < 768 px)
// Campos: alNavegar(), esMovil, abierto (cajón en móvil), colapsado (escritorio), abrir(), cerrar(), alternar(),
// enShell (la página está dentro del shell: en escritorio su encabezado lleva idioma y tema) y revelarTema (el
// interruptor de tema usa la transición circular sólo con GPU).
// Fuera del shell (p. ej. una página sin menú) devuelve funciones vacías: se puede llamar siempre.
import { createContext, useContext } from 'react';

const NADA = () => {};
export const NavegacionContext = createContext({
  alNavegar: NADA,
  esMovil: false,
  abierto: false,
  colapsado: false,
  abrir: NADA,
  cerrar: NADA,
  alternar: NADA,
  enShell: false,
  revelarTema: false,
});

export function useNavegacion() {
  return useContext(NavegacionContext);
}
